import script from "./ChristmasQuizCompleteWrongPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChristmasQuizCompleteWrongPage.vue?vue&type=script&setup=true&lang=ts"

import "./ChristmasQuizCompleteWrongPage.vue?vue&type=style&index=0&id=1bc6832a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bc6832a"]])

export default __exports__